module.exports = __webpack_public_path__ + "img/minilogo.e4e4be9a.svg";